import React, { useEffect, useRef } from 'react';

export type MaiConfirmDialogProps = {
  open: boolean;
  title: string;
  body?: string | null;
  confirmLabel?: string;
  cancelLabel?: string;
  danger?: boolean;
  busy?: boolean;
  onConfirm: () => void;
  onCancel: () => void;
};

export const MaiConfirmDialog: React.FC<MaiConfirmDialogProps> = ({
  open,
  title,
  body,
  confirmLabel = 'Confirmar',
  cancelLabel = 'Cancelar',
  danger = true,
  busy,
  onConfirm,
  onCancel,
}) => {
  const confirmRef = useRef<HTMLButtonElement>(null);

  useEffect(() => {
    if (!open) return;
    const t = window.setTimeout(() => confirmRef.current?.focus(), 40);
    const onKey = (e: KeyboardEvent) => {
      if (e.key === 'Escape') {
        e.preventDefault();
        onCancel();
      }
    };
    window.addEventListener('keydown', onKey);
    return () => {
      window.clearTimeout(t);
      window.removeEventListener('keydown', onKey);
    };
  }, [open, onCancel]);

  if (!open) return null;

  return (
    <div
      className="mai-confirm-backdrop"
      onClick={(e) => {
        e.stopPropagation();
        if (!busy) onCancel();
      }}
      role="presentation"
    >
      <div
        className="mai-confirm-dialog"
        role="alertdialog"
        aria-modal="true"
        aria-labelledby="mai-confirm-title"
        onClick={(e) => e.stopPropagation()}
      >
        <p className="mai-confirm-eyebrow">{danger ? 'Ação sensível' : 'Confirmação'}</p>
        <h2 id="mai-confirm-title" className="mai-confirm-title">{title}</h2>
        {body ? <p className="mai-confirm-body">{body}</p> : null}
        <p className="mai-confirm-note">
          Esta ação pode ser irreversível. Confirme apenas se tiver certeza.
        </p>
        <div className="mai-confirm-actions">
          <button type="button" className="mai-btn mai-btn-ghost" disabled={busy} onClick={onCancel}>
            {cancelLabel}
          </button>
          <button
            ref={confirmRef}
            type="button"
            className={`mai-btn ${danger ? 'mai-btn-danger' : ''}`}
            disabled={busy}
            onClick={onConfirm}
          >
            {busy ? 'Aguarde…' : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
};

export default MaiConfirmDialog;
